var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('core-app-bar'),_c('core-drawer'),_c('v-main',[_c('section-intro'),_c('section-class'),_c('section-reservation'),_c('section-review'),_c('section-place')],1),_c('core-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }